import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutTableCustomerQuotes extends Layout {
	sourceLtlQuoteList: DataSource;
	tableQuotes: Table;
}
